import { motion } from "framer-motion";

export const SectionHeading = ({
  overline,
  title,
  subtitle,
  align = "left",
  testid = "section-heading",
  highlight,
  invert = false,
}) => {
  const alignClass =
    align === "center" ? "text-center mx-auto items-center" : "text-left";

  const titleColor = invert ? "text-white" : "text-[#1F2937]";
  const subtitleColor = invert ? "text-white/85" : "text-[#64748B]";
  const overlineClass = invert
    ? "bg-white/20 backdrop-blur text-white border border-white/30"
    : "bg-[#12DDB5]/12 text-[#0b9a7c]";

  return (
    <motion.div
      data-testid={testid}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className={`flex flex-col ${alignClass} max-w-3xl`}
    >
      {overline && (
        <span
          className={`inline-flex self-start items-center gap-2 px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-[0.16em] ${overlineClass}`}
          style={{ alignSelf: align === "center" ? "center" : "flex-start" }}
        >
          {overline}
        </span>
      )}
      <h2
        className={`mt-4 text-3xl sm:text-4xl lg:text-[2.75rem] font-extrabold tracking-[-0.02em] leading-[1.1] ${titleColor}`}
      >
        {title}{" "}
        {highlight && (
          <span
            className={
              invert ? "text-[#3532B3]" : "text-gradient-brand"
            }
          >
            {highlight}
          </span>
        )}
      </h2>
      {subtitle && (
        <p className={`mt-5 text-lg leading-relaxed ${subtitleColor}`}>
          {subtitle}
        </p>
      )}
    </motion.div>
  );
};
